import { useLazyFetchConfiguredServiceDetailsQuery } from 'api/configured-service/configuredServiceCrud'
import { useEffect } from 'react'
import { useCSDetailsURLData } from 'api/configured-service/useCSDetailsURLData'

export const useCSDetailsCachedData = args => {
  const { selectFromResult = undefined, preferCacheValue = true, id: explicitId } = args || {}
  const { id: urlId } = useCSDetailsURLData()
  const id = explicitId ?? urlId
  const [fetchCSDetails, { data, isLoading, isFetching, isSuccess }] = useLazyFetchConfiguredServiceDetailsQuery({
    selectFromResult,
  })

  useEffect(() => {
    if (id && fetchCSDetails) {
      fetchCSDetails({ id }, preferCacheValue)
    }
  }, [fetchCSDetails, id, preferCacheValue])

  return { data, isLoading, isFetching, isSuccess }
}
